import React from 'react';

import {MenuContentItemLabel} from './MenuContentItemLabel';
import {MenuSectionContentItemLabel} from './MenuSectionContentItemLabel';
import {
    ensureMenuContentItemIsSectionContentItem,
    ItemType,
    MenuContentItem as MenuContentItemModel,
} from '@ael/core-api';

export interface MenuContentItemProps {
  item: MenuContentItemModel;
  isGrandChild?: boolean;
  onClick?: () => void;
}

export const MenuContentItem: React.FunctionComponent<MenuContentItemProps> = ({ item, isGrandChild, onClick }) => {
  switch (item.itemType) {
    case ItemType.Hotspot:
    case ItemType.SequencedFlowStep:
    case ItemType.Question:
    case ItemType.StartingMessage:
    case ItemType.BlindMapQuestion:
      return (
        <MenuContentItemLabel
          {...item}
          isGrandChild={isGrandChild}
          onClick={onClick}
          hideConnectingLines={item.itemType === ItemType.Hotspot}
        />
      );
    case ItemType.Section:
      ensureMenuContentItemIsSectionContentItem(item);
      return (
        <MenuSectionContentItemLabel
          title={item.title}
          isExpanded={item.isExpanded}
          trackingStatus={item.trackingStatus}
          onClick={onClick}
        />
      );
    default:
      return null;
  }
};
